<template>
    <v-navigation-drawer
            fixed
            :clipped="$vuetify.breakpoint.mdAndUp"
            app
            :value="drawer"
            @input="$emit('toggleDrawer', $event)"
    >
        <v-list dense>
            <template v-for="item in items">
                <v-list-tile @click="$router.push({name: item.route})" :key="item.text" ripple>
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{ item.text }}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>
<script>
    export default {
        props: {
            drawer: {
                type: Boolean,
            }
        },
        data: () => ({
            items: [
                {icon: 'contacts', text: 'Home', route: "dashboard"},
            ]
        })
    }
</script>